import {useContext, useEffect} from "react";
import {FormContext} from "@/components/form/Form.tsx";

export default function Field(
    {name, children, defaultValue, validate, forceValidate}:
    FieldProps
) {

    const form = useContext(FormContext);
    useEffect(() => {
        if (form.getValue(name) === undefined) {
            if(defaultValue) {
                form.setValue(name, defaultValue);
            }
        }
    }, [defaultValue, form]);

    useEffect(() => {
        if (forceValidate && validate) {
            form.setError(name, validate(form.getValue(name)));
        }
    }, [forceValidate, validate, form.getValue(name)]);


    function onChange(value: any) {
        form.setValue(name, value);
        form.touchField(name);
        if (form.getError(name) && validate) {
            form.setError(name, validate(value));
        }
    }


    function onBlur() {
        if (validate) {
            form.setError(name, validate(form.getValue(name)));
        }
    }

    return (
        <>
            {children?.({
                value: form.getValue(name),
                onChange: onChange,
                error: form.getError(name),
                onBlur: onBlur
            })}
        </>
    )
}